/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RenewalOrgItem } from './RenewalOrgItem';
import {
    RenewalOrgItemFromJSON,
    RenewalOrgItemFromJSONTyped,
    RenewalOrgItemToJSON,
    RenewalOrgItemToJSONTyped,
} from './RenewalOrgItem';
import type { Daylist } from './Daylist';
import {
    DaylistFromJSON,
    DaylistFromJSONTyped,
    DaylistToJSON,
    DaylistToJSONTyped,
} from './Daylist';
import type { DaylistCenterSupplier } from './DaylistCenterSupplier';
import {
    DaylistCenterSupplierFromJSON,
    DaylistCenterSupplierFromJSONTyped,
    DaylistCenterSupplierToJSON,
    DaylistCenterSupplierToJSONTyped,
} from './DaylistCenterSupplier';
import type { TransportLot } from './TransportLot';
import {
    TransportLotFromJSON,
    TransportLotFromJSONTyped,
    TransportLotToJSON,
    TransportLotToJSONTyped,
} from './TransportLot';
import type { Stock } from './Stock';
import {
    StockFromJSON,
    StockFromJSONTyped,
    StockToJSON,
    StockToJSONTyped,
} from './Stock';

/**
 * 
 * @export
 * @interface Stocks
 */
export interface Stocks {
    /**
     * 
     * @type {number}
     * @memberof Stocks
     */
    datacount: number | null;
    /**
     * 
     * @type {number}
     * @memberof Stocks
     */
    maxcount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof Stocks
     */
    lastUpdateDatetime: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Stocks
     */
    optimizeRangeStartDate: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Stocks
     */
    optimizeRangeEndDate: Date | null;
    /**
     * 
     * @type {Array<Stock>}
     * @memberof Stocks
     */
    list: Array<Stock>;
    /**
     * 
     * @type {Array<Daylist>}
     * @memberof Stocks
     */
    daylist: Array<Daylist>;
    /**
     * 
     * @type {Array<DaylistCenterSupplier>}
     * @memberof Stocks
     */
    daylistCenterSupplier: Array<DaylistCenterSupplier>;
    /**
     * 
     * @type {Array<RenewalOrgItem>}
     * @memberof Stocks
     */
    renewalOrgItemList: Array<RenewalOrgItem>;
    /**
     * 
     * @type {Array<TransportLot>}
     * @memberof Stocks
     */
    transportLotList: Array<TransportLot>;
}

/**
 * Check if a given object implements the Stocks interface.
 */
export function instanceOfStocks(value: object): value is Stocks {
    if (!('datacount' in value) || value['datacount'] === undefined) return false;
    if (!('maxcount' in value) || value['maxcount'] === undefined) return false;
    if (!('lastUpdateDatetime' in value) || value['lastUpdateDatetime'] === undefined) return false;
    if (!('optimizeRangeStartDate' in value) || value['optimizeRangeStartDate'] === undefined) return false;
    if (!('optimizeRangeEndDate' in value) || value['optimizeRangeEndDate'] === undefined) return false;
    if (!('list' in value) || value['list'] === undefined) return false;
    if (!('daylist' in value) || value['daylist'] === undefined) return false;
    if (!('daylistCenterSupplier' in value) || value['daylistCenterSupplier'] === undefined) return false;
    if (!('renewalOrgItemList' in value) || value['renewalOrgItemList'] === undefined) return false;
    if (!('transportLotList' in value) || value['transportLotList'] === undefined) return false;
    return true;
}

export function StocksFromJSON(json: any): Stocks {
    return StocksFromJSONTyped(json, false);
}

export function StocksFromJSONTyped(json: any, ignoreDiscriminator: boolean): Stocks {
    if (json == null) {
        return json;
    }
    return {
        
        'datacount': json['datacount'],
        'maxcount': json['maxcount'],
        'lastUpdateDatetime': (json['last_update_datetime'] == null ? null : new Date(json['last_update_datetime'])),
        'optimizeRangeStartDate': (json['optimize_range_start_date'] == null ? null : new Date(json['optimize_range_start_date'])),
        'optimizeRangeEndDate': (json['optimize_range_end_date'] == null ? null : new Date(json['optimize_range_end_date'])),
        'list': ((json['list'] as Array<any>).map(StockFromJSON)),
        'daylist': ((json['daylist'] as Array<any>).map(DaylistFromJSON)),
        'daylistCenterSupplier': ((json['daylist_center_supplier'] as Array<any>).map(DaylistCenterSupplierFromJSON)),
        'renewalOrgItemList': ((json['renewal_org_item_list'] as Array<any>).map(RenewalOrgItemFromJSON)),
        'transportLotList': ((json['transport_lot_list'] as Array<any>).map(TransportLotFromJSON)),
    };
}

export function StocksToJSON(json: any): Stocks {
    return StocksToJSONTyped(json, false);
}

export function StocksToJSONTyped(value?: Stocks | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'datacount': value['datacount'],
        'maxcount': value['maxcount'],
        'last_update_datetime': value['lastUpdateDatetime'] == null ? value['lastUpdateDatetime'] : value['lastUpdateDatetime'].toISOString(),
        'optimize_range_start_date': value['optimizeRangeStartDate'] == null ? value['optimizeRangeStartDate'] : value['optimizeRangeStartDate'].toISOString().substring(0,10),
        'optimize_range_end_date': value['optimizeRangeEndDate'] == null ? value['optimizeRangeEndDate'] : value['optimizeRangeEndDate'].toISOString().substring(0,10),
        'list': ((value['list'] as Array<any>).map(StockToJSON)),
        'daylist': ((value['daylist'] as Array<any>).map(DaylistToJSON)),
        'daylist_center_supplier': ((value['daylistCenterSupplier'] as Array<any>).map(DaylistCenterSupplierToJSON)),
        'renewal_org_item_list': ((value['renewalOrgItemList'] as Array<any>).map(RenewalOrgItemToJSON)),
        'transport_lot_list': ((value['transportLotList'] as Array<any>).map(TransportLotToJSON)),
    };
}

